module.exports = __webpack_public_path__ + "img/map-position-dot.d313b9c7.svg";